import {RsnSelect} from '@raison/ui-kit';
import {useQuery} from '@tanstack/react-query';
import React from 'react';
import {Country, CountryCodeFormat, SomeCountryCode, useCountriesListOptions} from '../model/Country';
import {CountryFlag, usePreloadCountriesSprite} from './CountryFlag';

export interface CountryPickerProps extends Omit<RsnSelect.Props<SomeCountryCode | null>, 'options'> {
    /**
     * @deprecated
     * @see https://jira.raison.digital/browse/RAISON-5887?focusedId=92933&page=com.atlassian.jira.plugin.system.issuetabpanels%3Acomment-tabpanel#comment-92933
     */
    format?: CountryCodeFormat;
}

export function CountryPicker({value, onChange, disabled, format = 'alpha2', ...props}: CountryPickerProps) {
    const {isLoading, isError, ...query} = useQuery({
        ...useCountriesListOptions(),
        select: data => data.map(country => countryToOptions(country, format)),
    });

    let options = query.data;
    if (isLoading || isError) {
        options = [];
    }
    if (isError) {
        props.helperText = 'An error occurred. Try reopening this page.';
        props.isInvalid = true;
    }

    usePreloadCountriesSprite();

    return (
        <RsnSelect.Search
            //
            withIcon
            virtualized
            {...props}
            options={options}
            value={value}
            onChange={onChange}
            disabled={isLoading || isError || disabled}
        />
    );
}

function countryToOptions(country: Country, format: CountryCodeFormat): RsnSelect.Option<SomeCountryCode | null> {
    return {
        icon: {element: <CountryFlag iso={country.alpha2} />},
        label: country.name,
        value: country[format],
    };
}
